import serviceBase from '@/services/serviceBase'
import { ApiBooleanResult, ApiResult } from '@/services/data'

export default {
  async getBillHistory (coin: string): Promise<ApiResult<any>> {
    return await serviceBase.tryPostResult<any>('/Okx/BillHistory')
  },
  async getBalances (coin: string): Promise<ApiResult<any>> {
    return await serviceBase.tryPostResult<any>('/Okx/Balances')
  }
}
